// extracted by mini-css-extract-plugin
export default {"bg":"CreditCard_bg__phW3B","main":"CreditCard_main__MMBG0","left":"CreditCard_left__PSfBE","right":"CreditCard_right__h+xg1"};